module.exports = __webpack_public_path__ + "media/luxury-2026/estate-side-drone-a4267d2e.jpg";